import React from 'react';
import { Box, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Link } from '../Link';

interface IProps {
    className?: string;
}

const BasePageFooter = ({ className }: IProps) => {
    const { t } = useTranslation();

    return (
        <Box className={className}>
            <Typography className="app-title" variant="h2">
                {t('footer.title')}
            </Typography>
            <Box className="footerSectionWrapper">
                <Box className="footerSection">
                    <Box display="flex">
                        <Link
                            href={t('footer.termsLink')}
                            target="_blank"
                            to=""
                        >
                            {t('footer.terms')}
                        </Link>
                    </Box>
                    <Box display="flex">
                        <Link
                            href={t('footer.privacyLink')}
                            target="_blank"
                            to=""
                        >
                            {t('footer.privacy')}
                        </Link>
                    </Box>
                </Box>
                <Box className="footerSection">
                    <Box display="flex">
                        <Link
                            href={t('footer.cookiesLink')}
                            target="_blank"
                            to=""
                        >
                            {t('footer.cookies')}
                        </Link>
                    </Box>
                    <Box display="flex">
                        <Typography>{t('footer.copyrightNotice')}</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export const PageFooter = styled(BasePageFooter)`
    width: 100%;
    background-color: ${({ theme }) => theme.palette.primary.main};
    padding: ${({ theme }) => `${theme.spacing(13)}px ${theme.spacing(5)}px`};
    color: ${({ theme }) => theme.palette.background.paper};

    .app-title {
        text-transform: uppercase;
    }

    ${Link} {
        color: ${({ theme }) => theme.palette.background.paper};
        text-decoration: none;
        display: block;
        margin-bottom: ${({ theme }) => `${theme.spacing(1)}px`};
    }

    .footerSection {
        width: 100%;
    }

    .footerSectionWrapper {
        display: flex;
        flex-direction: column;
        margin-top: ${({ theme }) => `${theme.spacing(5)}px`};
    }

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['sm']}px`}) {
        .footerSectionWrapper {
            flex-direction: row;

            .footerSection {
                width: 50%;
            }
        }

        ${Link} {
            margin-bottom: ${({ theme }) => `${theme.spacing(7)}px`};
        }
    }
`;
